import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit, OnChanges {
  @Input()
  public disabled = false; // Prevent selection and disable input
  @Input()
  public altClass: string; // Replace dropdown class (optional)
  @Input()
  public model: any; // Default Selected element (optional)
  @Input()
  public modelValue: any; // Default selected element value (optional)
  @Input()
  public elements: any[]; // Data list
  @Input()
  public placeholder: string; // Displayed when nothing is selected (optional)
  @Input()
  public labelFieldName: string; // Property to display in the dropdown from each element (optional if elements is type(elements) === 'string')
  @Input()
  public valueFieldName: string; // Set this property if the model is an object but the emitted value must be only a field of the object (required if modelValue is set)
  @Input()
  public id: string; // ID of the DOM element

  @Output()
  public selectedElement: EventEmitter<any>;

  constructor() {
    this.selectedElement = new EventEmitter<any>();
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.elements && this.valueFieldName && this.modelValue) {
      this.model = this.elements.filter(
        c => c[this.valueFieldName] === this.modelValue
      )[0];
    }
    if (this.elements && this.valueFieldName && !this.modelValue) {
      this.model = this.placeholder;
    }
  }

  // On click emit the whole choosen element
  public onClick(element: any): void {
    if (this.valueFieldName) {
      this.selectedElement.emit(element[this.valueFieldName]);
    } else {
      this.selectedElement.emit(element);
    }
  }
}
